import React, { Fragment, useEffect, useRef, useState } from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import DragDrop from "../DragDrop/DragDrop";
import ApprovalsScreen from "./ApprovalsScreen";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import moment from "moment";
import InputMaskReadOnly from "../App/InputMaskReadOnly";
import { useGlobalState } from "../Context/GlobalStateContext";
import DownloadPopup from "../App/DownloadPopup";
export default function CreditNotesApproval() {
  const [showAnimation, setShowAnimation] = useState(false);
  const globalState = useGlobalState();
  const [programList, setProgramList] = useState<any>([]);
  const [quarterList, setQuarterList] = useState<any>([]);

  const [importerList, setImporterList] = useState<any>([]);

  const [filterData, setFilterData] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    IBBScorecardID: 0,
    PFIDealerID: 0,
    PFIBrandID: 2,
  });

  const [reportFilterData, setReportFilterData] = useState({
    StartDate: null,
    EndDate: null,
  });

  const [creditNotesData, setCreditNotesData] = useState<any>([]);
  const [creditNotesImporters, setCreditNotesImporters] = useState<any>([]);
  const [creditNotesInvoices, setCreditNotesInvoices] = useState<any>([]);
  const [modelList, setModelList] = useState<any>([]);

  const [invoiceData, setInvoiceData] = useState<any>({});

  //MM:: Approval related data
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;

  const [downloadInputData, setDownloadInputData] = useState<any>([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpFileURL, setPopUpFileURL] = useState("");
  const [popUpMessage, setPopUpMessage] = useState(
    "Data has been exported to file successfully!"
  );

  const [popUpMessageModal, setPopUpMessageModal] = useState(false);
  const [creditNoteDetailsModal, setCreditNoteDetailsModal] = useState(false);

  const [inputData, setInputData] = useState<any>({});

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = filterData.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = filterData.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = filterData.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = filterData.ProgramID;

    setFilterData((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
    }));

    IBBProgramGetProgramListForScorecard(
      IBBProgramID,
      QuarterID,
      IBBScorecardID,
      PFIDealerID
    );
  }, []);

  useEffect(() => {
    if (filterData.ProgramID > 0 && filterData.QuarterID > 0) {
      IBBProgramGetScorecardListForScorecard();

      var filtered = programList.filter(
        (item: any) => item.IBBProgramID == filterData.ProgramID
      );

      let year = 2023;
      if (filtered.length > 0) year = filtered[0]["NumericYear"];
      let startDate = new Date(year, 3, 1);
      let endDate = new Date(year, 5, 30);
      if (filterData.QuarterID == 2) {
        startDate = new Date(year, 6, 1);
        endDate = new Date(year, 8, 31);
      } else if (filterData.QuarterID == 3) {
        startDate = new Date(year, 9, 1);
        endDate = new Date(year, 11, 31);
      } else if (filterData.QuarterID == 4) {
        startDate = new Date(year + 1, 0, 1);
        endDate = new Date(year + 1, 2, 31);
      }

      setReportFilterData((prevState: any) => ({
        ...prevState,
        StartDate: startDate,
        EndDate: endDate,
      }));
    }
  }, [filterData.ProgramID, filterData.QuarterID]);

  useEffect(() => {
    if (filterData.ProgramID > 0 && filterData.QuarterID > 0)
      IBBScorecardCreditNoteGetDataForApproval();
  }, [filterData]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number,
    IBBScorecardID: number,
    PFIDealerID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = filterData.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = QuarterID;
    object.pfidealerid = PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setFilterData((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            setImporterList(result[1]);

            setQuarterList(result[2]);
            if (QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setFilterData((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetScorecardListForScorecard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = filterData.ProgramID;
    object.numericquarter = filterData.QuarterID;
    object.pfidealerid = filterData.PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetScorecardListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            setImporterList(result[0]);

            // if (result[0].length > 0) {
            //   let IBBScorecardID = result[0][0].PID;
            //   setfilterData((prevState: any) => ({
            //     ...prevState,
            //     IBBScorecardID: IBBScorecardID,
            //   }));
            // }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBScorecardCreditNoteGetDataForApproval() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.ibbscorecardid = filterData.IBBScorecardID;
    object.ibbprogramstageid = 25; //MM:: TODO check this approval type
    object.ibbprogramsectionid = 0;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecardCreditNote/IBBScorecardCreditNoteGetDataForApproval",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            setCreditNotesImporters(result[0]);
            setCreditNotesInvoices(result[1]);
            setCreditNotesData(result[2]);
            setRequiredApprovalUser(result[3]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function triggerApprovalParent() {
    IBBScorecardCreditNoteGetDataForApproval();
  }

  function IBBScorecardGetModelLevelDataForCreditNote(
    IBBScorecardID: number,
    PFIBrandID: number,
    IBBScorecardCreditNoteID: number,
    Amount: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.pfidealerid = filterData.PFIDealerID;
    object.ibbscorecardid = IBBScorecardID;
    object.pfibrandid = PFIBrandID;
    object.ibbscorecardcreditnoteid = IBBScorecardCreditNoteID;
    object.type = 2;
    //object.amount = Amount;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecardCreditNote/IBBScorecardGetModelLevelDataForCreditNote",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            setModelList(result[0]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBScorecardInvoiceSaveCustomForInvoiceChecked(
    IBBScorecardInvoiceID: number,
    IsInvoicechecked: boolean
  ) {
    if (IsInvoicechecked) {
      let object = {} as any;
      object.appid = AppContext.App;
      object.ibbscorecardinvoiceid = IBBScorecardInvoiceID;
      setShowAnimation(true);
      axiosAuth
        .post(
          AppContext.AppBaseURL +
            "api/IBBScorecardInvoice/IBBScorecardInvoiceSaveCustomForInvoiceChecked",
          object
        )
        .then((response) => {
          setShowAnimation(false);
          if (response.data.Status == 1) {
            let result = response.data.Data;
            IBBScorecardCreditNoteGetDataForApproval();
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }

  function IBBScorecardCreditNoteGetDataForCreditDebitReportByApprovalDate() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = filterData.ProgramID;
    object.numericquarter = filterData.QuarterID;
    object.ibbscorecardid = filterData.IBBScorecardID;
    object.startdate = reportFilterData.StartDate;
    object.enddate = reportFilterData.EndDate;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecardCreditNote/IBBScorecardCreditNoteGetDataForCreditDebitReportByApprovalDate",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          setDownloadInputData(result[0]);
          if (result[0].length > 0) {
            setPopUpFileURL(result[0][0].DownloadData);
            setPopUpMessage("Data has been exported to file successfully!");
            setShowPopUp(true);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function DownloadPopupCallBack() {
    setShowPopUp(false);
    setPopUpFileURL("");
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}

      <DownloadPopup
        ShowPopup={showPopUp}
        FileLink={popUpFileURL}
        Message={popUpMessage}
        DownloadPopupCallBack={DownloadPopupCallBack}
      />

      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Internal Credit Note Requests Approval</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div style={{ width: "33.33%" }}>
              <select
                className="select-md"
                value={filterData.ProgramID}
                onChange={(e) => {
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(
                    Number(e.target.value),
                    0,
                    0,
                    0
                  );
                }}
              >
                {programList &&
                  programList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"programtop" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>

              <select
                style={{ marginLeft: 5 }}
                className="select-md"
                value={filterData.QuarterID}
                onChange={(e) => {
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                }}
              >
                {quarterList &&
                  quarterList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"quartertop" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
            </div>
            <div>
              <select
                className="select-lg"
                value={filterData.IBBScorecardID}
                onChange={(e) =>
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    IBBScorecardID: Number(e.target.value),
                  }))
                }
              >
                <option value={0} key={"importertop" + 0}>
                  All
                </option>
                {importerList &&
                  importerList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"importertop" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
            </div>
            <span style={{ width: "33.33%" }}></span>

            <div>
              <input
                type="date"
                className="input-date-credits"
                value={moment(reportFilterData.StartDate).format("YYYY-MM-DD")}
                onChange={(e) => {
                  setReportFilterData((prevState: any) => ({
                    ...prevState,
                    StartDate: e.target.value,
                  }));
                }}
              ></input>
            </div>

            <div>
              <input
                type="date"
                className="input-date-credits"
                value={moment(reportFilterData.EndDate).format("YYYY-MM-DD")}
                onChange={(e) => {
                  setReportFilterData((prevState: any) => ({
                    ...prevState,
                    EndDate: e.target.value,
                  }));
                }}
              ></input>
            </div>

            <div>
              <a
                className="btn-link"
                onClick={() =>
                  IBBScorecardCreditNoteGetDataForCreditDebitReportByApprovalDate()
                }
              >
                Download Report
              </a>
            </div>
            <div></div>
          </div>

          <div className="section-table mb-10 exception-up">
            {creditNotesImporters &&
              creditNotesImporters.map((itemImporter: any, index: any) => (
                <React.Fragment
                  key={"importerlist" + itemImporter.IBBScorecardID}
                >
                  <div className="buis-case case-back plr-20">
                    <div className="excep-heading">
                      <span>{itemImporter.IBBScorecardName}</span>
                    </div>
                    <div className="crdn-1">
                      <div className="crdn-2">
                        <div className="crdn-5">
                          {creditNotesInvoices &&
                            creditNotesInvoices.map((item: any, index: any) => (
                              <div className="crdn-3">
                                {itemImporter.IBBScorecardID ==
                                  item.IBBScorecardID && (
                                  <React.Fragment
                                    key={
                                      "itemlist" + item.IBBScorecardCreditNoteID
                                    }
                                  >
                                    <div className="exception-grid">
                                      <div className="exceptions-left">
                                        <div className="flex-items buis-head">
                                          <span>
                                            Amount:{" "}
                                            {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                              itemImporter.CurrencyID
                                            )}
                                            {item.InvoiceAmount.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                              }
                                            )}
                                          </span>
                                          <span>
                                            Brand: {item.PFIBrandNameInvoice}
                                          </span>
                                          <span className="flex-items">
                                            Invoice:{" "}
                                            <a
                                              className="btn-primary btn-grid"
                                              href={item.FileURL}
                                              target="blank"
                                            >
                                              <img
                                                src="images/download.svg"
                                                width={12}
                                                height={12}
                                              />
                                            </a>
                                          </span>
                                          <span className="flex-items">
                                            <input
                                              type="checkbox"
                                              className="input-check"
                                              disabled={item.IsInvoiceChecked}
                                              title={
                                                item.IsInvoiceChecked
                                                  ? "Checked By: " +
                                                    item.InvoiceCheckedByName
                                                  : ""
                                              }
                                              checked={item.IsInvoiceChecked}
                                              onChange={(e) =>
                                                IBBScorecardInvoiceSaveCustomForInvoiceChecked(
                                                  item.IBBScorecardInvoiceID,
                                                  true
                                                )
                                              }
                                            />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </React.Fragment>
                                )}
                              </div>
                            ))}
                        </div>
                        <div className="crdn-6">
                          {creditNotesData &&
                            creditNotesData.map((item: any, index: any) => (
                              <>
                                {itemImporter.IBBScorecardID ==
                                  item.IBBScorecardID && (
                                  <React.Fragment
                                    key={
                                      "itemlist" + item.IBBScorecardCreditNoteID
                                    }
                                  >
                                    <div className="crdn-4">
                                      <div className="exception-grid">
                                        <div className="exceptions-left">
                                          <div className="flex-items buis-head org-font">
                                            <span>
                                              Originator:
                                              <br /> {item.GeneratedByName}
                                            </span>
                                            <span>
                                              Date:
                                              <br />
                                              {moment(
                                                item.GeneratedTimestamp
                                              ).format("DD/MM/YYYY")}
                                            </span>
                                            <span>
                                              Amount:
                                              <br />
                                              {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                item.CurrencyID
                                              )}
                                              {item.Amount.toLocaleString(
                                                undefined,
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 0,
                                                }
                                              )}
                                            </span>
                                            <span>
                                              Brand:
                                              <br /> {item.PFIBrandName}
                                            </span>
                                            <a
                                              className="btn-primary btn-grid"
                                              title="View Details"
                                              onClick={() => {
                                                setInputData(item);
                                                IBBScorecardGetModelLevelDataForCreditNote(
                                                  item.IBBScorecardID,
                                                  item.PFIBrandID,
                                                  item.IBBScorecardCreditNoteID,
                                                  item.Amount
                                                );
                                                setCreditNoteDetailsModal(true);
                                              }}
                                            >
                                              <img
                                                src="images/eye.svg"
                                                width={15}
                                                height={15}
                                              />
                                            </a>
                                          </div>
                                        </div>
                                        <div className="pg-importers appr-grid grid-signoff">
                                          <div className="appr-main approved-overlay">
                                            <div className="exceptions-right">
                                              <div className="excp-approval">
                                                <ApprovalsScreen
                                                  approvalObjectType={25}
                                                  IBBProgramID={
                                                    filterData.ProgramID
                                                  }
                                                  QuarterID={
                                                    filterData.QuarterID
                                                  }
                                                  IBBProgramSectionID={0}
                                                  ApprovalTextType={1}
                                                  approvalObjectID={
                                                    item.IBBScorecardCreditNoteID
                                                  }
                                                  uploadObjectType={
                                                    AppContext.FileUploadObjectTypeCreditNoteApprovalFile
                                                  }
                                                  requiredApprovalUser={
                                                    requiredApprovalUser
                                                  }
                                                  triggerApprovalParent={
                                                    triggerApprovalParent
                                                  }
                                                ></ApprovalsScreen>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </React.Fragment>
                                )}
                              </>
                            ))}
                        </div>
                      </div>
                    </div>
                    <div className="crdn-9">
                      <div className="crdn-10">
                        <span>
                          {AppContext.GetCurrencyIconBasedOnCurrencyID(
                            itemImporter.CurrencyID
                          )}
                          {itemImporter.InvoiceAmount?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                        {itemImporter.InvoiceAmount ==
                        itemImporter.CreditNoteAmount ? (
                          <img src="images/equal.svg" width={19} height={18} />
                        ) : (
                          <img
                            src="images/notequal.svg"
                            width={18}
                            height={18}
                          />
                        )}
                        <span>
                          {AppContext.GetCurrencyIconBasedOnCurrencyID(
                            itemImporter.CurrencyID
                          )}
                          {itemImporter.CreditNoteAmount.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                      <span></span>
                    </div>
                  </div>
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}

      {creditNoteDetailsModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Details</h3>
                <a
                  className="close-help"
                  onClick={() => setCreditNoteDetailsModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              <div className="page--contents">
                <div className="page--data detail-scroll">
                  <div className="type-form">
                    <div className="flex-type">
                      <span>Importer:</span>
                      {inputData.IBBScorecardName}
                    </div>

                    <div className="flex-type">
                      <span>Brand:</span>
                      {inputData.PFIBrandName}
                    </div>

                    <div className="flex-type">
                      <span>Date:</span>
                      <span className="d-input-tp">
                        {moment(inputData.GeneratedTimestamp).format(
                          "DD/MM/YYYY"
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="section-table">
                    <span className="span-flex c-red war-flex">
                      COMPLETE FOR VRM / EXT WARRANTY ONLY
                    </span>
                    <span className="span-flex c-red">
                      Note: One Brand Per Submission
                    </span>
                    {modelList.length > 0 && (
                      <table
                        className="part-head trend-table fixed-table"
                        id="tblProgramList"
                      >
                        <thead>
                          <tr>
                            <th>Model</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {modelList &&
                            modelList.map((item: any, index: any) => (
                              <React.Fragment key={"sectioncalcdata" + index}>
                                <tr>
                                  <td>{item.ModelName}</td>
                                  <td className="text-right">
                                    {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                      inputData.CurrencyID
                                    )}
                                    {item.ModelValueBasedOnPercentage?.toLocaleString(
                                      undefined,
                                      {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                        </tbody>
                      </table>
                    )}
                    <div className="flex-type crd-note">
                      <span>Total CREDIT Note Request:</span>
                      <InputMaskReadOnly
                        Disabled={true}
                        Prefix={AppContext.GetCurrencyIconBasedOnCurrencyID(
                          inputData.CurrencyID
                        )}
                        Suffix={""}
                        ToFixed={0}
                        ClassName=""
                        ColumnName="1"
                        Value={Number(inputData.Amount)}
                        PID={1}
                      />
                    </div>
                  </div>

                  <div className="section-table">
                    <span className="org-disclaimer">
                      <input
                        type="checkbox"
                        className="input-check"
                        checked={true}
                      />
                      DISCLAIMER - As the originator of this internal
                      Credit/Debit Note request - I confirm that the terms of
                      the programme have been met and that this claim is
                      consistent with the approved programme and is contained
                      within the approved value.
                    </span>
                    <div className="org-dt">
                      <div className="org-main">
                        <span className="org-til">
                          {inputData.GeneratedByName}
                        </span>
                        <span>Originator:</span>
                      </div>
                      <div className="org-main">
                        <span className="org-til">
                          {moment(inputData.OriginatedTimestamp).format(
                            "DD/MM/YYYY"
                          )}
                        </span>
                        <span>Date:</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="buis-case plr-20">
              {modelList.length > 0 && (
                <table
                  className="part-head trend-table fixed-table"
                  id="tblData"
                >
                  <thead>
                    <tr>
                      <th>Model</th>
                      <th>Amount</th>
                      <th>Fiscal Year / Quarter Covered</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modelList &&
                      modelList.map((item: any, index: any) => (
                        <React.Fragment key={"sectioncalcdata" + index}>
                          <tr>
                            <td>{item.ModelName}</td>
                            <td className="text-right">
                            {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                              currencyID
                                            )}
                              {item.ModelValueBasedOnPercentage?.toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }
                              )}
                            </td>
                            <td></td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              )}
                </div> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
